<template>
  <s-modal-card class="sm-modal export-list">
    <div slot="title">
      Export Task
    </div>

    <div slot="body" class="page-body">
      <ul>
        <li class="flex list-item" v-for="(item, index) in export_list" :key="index">
          <s-row align="middle" class="gutter">
            <s-col xs1>
              <s-icon icon="doc"></s-icon>
            </s-col>

            <s-col xs9>
              <span class="file-info">{{ item.filename }}</span>
            </s-col>

            <s-col xs4>
              <span>{{ item.status === 1 ? (item.file_size / 1000).toFixed(1) + 'k' : '--' }}</span>
            </s-col>

            <s-col xs3>
              <span>{{ item.status === 1 ? item.export_time + 's' : '--' }}</span>
            </s-col>

            <s-col xs2>
              <span :class="status_name[item.status]">{{ status_name[item.status] }}</span>
            </s-col>

            <s-col xs5 class="right">
              <span class="action">
                <s-btn
                  icon
                  @click.native="downloadExportFile(item.task_id)"
                  :disabled="item.status !== 1"
                >
                  <s-icon icon="download"></s-icon>
                </s-btn>
                <s-btn icon @click.native="delExportTask(item.task_id)">
                  <s-icon icon="delete"></s-icon>
                </s-btn>
              </span>
            </s-col>
          </s-row>
        </li>
      </ul>
    </div>

    <div slot="footer" class="text-right mt-4">
      <s-btn @click.native="clearExportTasks" :loading="loading" :readonly="loading">
        clear
        <s-icon class="icon-right" :icon="loading ? 'loading' : ''"></s-icon>
      </s-btn>
    </div>
  </s-modal-card>
</template>

<script>
import Qs from 'qs'
import { windowOpen } from '@/js/common'

export default {
  name: 'export-list',
  data() {
    return {
      loading: false,
      status_name: {
        0: 'pending',
        1: 'complete',
        2: 'fail',
      },
      export_list: [],
    }
  },
  created() {
    this.getExportTasks()
    this.checkExportStatus()
  },
  methods: {
    getExportTasks() {
      this.loading = true
      this.$http
        .get('/api/data/export/list/')
        .then(res => {
          this.loading = false
          this.export_list = res.data
        })
        .catch(error => {
          this.loading = false
          this.notifyError(error)
        })
    },

    downloadExportFile(task_id) {
      let params = {
        task_id: task_id,
      }
      let url = '/api/data/export/download/'
      let paramsStr = Qs.stringify(params, { arrayFormat: 'repeat' })
      windowOpen(url + '?' + paramsStr, url, 'download')
    },

    delExportTask(task_id) {
      this.confirmOpen(() => {
        this.loading = true
        this.$http
          .post('/api/data/export/delete/', {
            task_id: task_id,
          })
          .then(() => {
            this.getExportTasks()
            this.loading = false
            this.notifyOpen('Success')
          })
          .catch(error => {
            this.loading = false
            this.notifyError(error)
          })
      })
    },

    clearExportTasks() {
      this.confirmOpen(() => {
        this.loading = true
        this.$http
          .post('/api/data/export/clear/')
          .then(() => {
            this.loading = false
            this.export_list = []
            this.notifyOpen('Success')
          })
          .catch(error => {
            this.loading = false
            this.notifyError(error)
          })
      })
    },

    // 轮询导出状态
    checkExportStatus() {
      let count = 0
      this.timer = setInterval(() => {
        this.getExportTasks()
        if (this.stopCheckExport()) {
          clearInterval(this.timer)
        }
        count += 1
        if (count === 80) {
          let task_ids = new Set()
          for (let i = 0; i < this.export_list.length; i++) {
            let task = this.export_list[i]
            if (task.status === 0) {
              task.status = 2
              task_ids.add(task.task_id)
            }
          }
          this.$http
            .post('/api/data/export/timeout/', {
              task_ids: JSON.stringify(Array.from(task_ids)),
            })
            .then(() => {})
            .catch(error => {
              this.notifyError(error)
            })
          clearInterval(this.timer)
        }
      }, 10000)
    },

    // 当列表为空或列表中所有任务状态都不为pending时停止轮询
    stopCheckExport() {
      for (let i = 0; i < this.export_list.length; i++) {
        if (!this.export_list[i].status) {
          return false
        }
      }
      return true
    },
  },
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
.export-list
  width: 650px;
  border-radius: 5px;
  li
    padding: 15px 12px 15px 20px;
    &:hover
      background-color: #f8f8f8;
  .page-body
    padding: 0;
    color: #333;
    font-size: 14px;
    height: 380px;
    overflow-y: auto;
    overflow-x: hidden;
    .list-item
      width: 100%;
  .file-info
    word-break: break-word;
  .pending
    color: #999;
  .complete
    color: #10ad8a;
  .fail
    color: #df6977;
  .action
    text-align: right;
    margin: 0;
    .btn
      padding: 0;
      border: 0;
      font-size: 12px;
      background-color: inherit;
      &[disabled]
        background-color: inherit !important;
        color: #666;
      &:hover
        color: #666;
  .note
    padding-top: 20px;
    color: #999;
  .row.row-flex-middle
    width: 100%;
  .right
    text-align: right;
  .modal-card-body
    overflow: visible;
</style>
